import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import Row from '@src/components/AdvertisingCampaign/Form/Row'
import GroupHead from '@src/components/AdvertisingCampaign/Form/GroupHead'
import RadioGroup from '@src/components/AdvertisingCampaign/Form/RadioGroup'
import CheckboxGroup from '@src/components/AdvertisingCampaign/Form/CheckboxGroup'
import CheckableGroup from '@src/components/AdvertisingCampaign/Form/CheckableGroup'
import Textarea from '@iui-kit/components/Textarea'
import { Formik } from '@src/types/BriefSearch/formikProps'
import * as FIELDS from '@src/constants/AdvertisingBriefs'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepTwo: React.FC<HOCProps> = props => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.search.step.two.title">
      <GroupHead title="Brief.search.step.two.subTitle" />
      <GroupHead
        title="Brief.search.step.two.showRegions.title"
        subTitle="Brief.search.step.two.showRegions.subTitle"
      />
      <Row>
        <Textarea
          size="m"
          name={FIELD_NAMES.REGION}
          onChange={handleChange}
          handleBlur={handleBlur}
          value={values[FIELD_NAMES.REGION]}
          isValid={!errors[FIELD_NAMES.REGION] || !touched[FIELD_NAMES.REGION]}
          placeholder={formatMessage({ id: 'Brief.search.field.showRegions.placeholder' })}
        />
      </Row>
      <Row>
        <CheckableGroup label={'Brief.field.gender.label'}>
          <RadioGroup name={FIELD_NAMES.GENDER} inputs={FIELDS.GENDERS} />
        </CheckableGroup>
      </Row>
      <Row>
        <CheckableGroup label={'Brief.field.age.label'}>
          <CheckboxGroup name={FIELD_NAMES.AGE} inputs={FIELDS.AGES} />
        </CheckableGroup>
      </Row>
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepTwo)
